<h1 class="page-title mb-5"> أحدث الأصدارات </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <ul>
                    <li>منشورات المسئولية المجتمعية للشركات </li>
                    <a href="https://drive.google.com/drive/folders/1GAatO5vW7jRdchS6foN1c-_i0vHctnJ5"> اضغط هنا</a>
                    <a href="../../assets/GAFI_CSR_Flyer.pdf">اضغط هنا </a>
                    <li>مفاهيم أخري متعلقة بمفهوم المسئولية المجتمعية للشركات</li>
                    <a class="d-block"
                        href="../../assets/مفاهيم أخري متعلقة بمفهوم المسئولية المجتمعية للشركات.pdf">اضغط هنا </a>
                    <li>أهم المرجعيات الدولية المعنية بالمسئولية المجتمعية وسلوك الأعمال المسئول </li>
                    <a class="d-block"
                        href="../../assets/سلسلة مرجعيات المسئولية المجتمعية للشركات_الورقة الأولي الإطار العام.pdf">اضغط
                        هنا </a>
                    <a class="d-block" href="../../assets/الورقة الثانية_ الميثاق العالمي للأمم المتحدة.pdf">اضغط هنا
                    </a>
                    <a class="d-block" href="../../assets/الورقة الثالثة_ معيار الأيزو 26000.pdf">اضغط هنا </a>


                </ul>
            </div>
            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>